export type AtVirtualClinicTreatmentType =
  'S' | 'I' | 'E';

export const AT_VIRTUAL_CLINIC_TREATMENT_TYPE_DISPLAY_NAMES: { [treatmentType in AtVirtualClinicTreatmentType]: string } = {
  S: 'Stationär',
  I: 'Spitalsambulant',
  E: 'Extramural ambulant'
};
